import { config_settings } from '@/config.js';
import Vue from 'vue';

const baseApiUrl = config_settings.RESOURCE_SERVER_URL;

export const getSections = () => {
  return Vue.$http.get(baseApiUrl + '/GET/sections');
};

export const getSubSection = (codSubSec) => {
  return Vue.$http.get(baseApiUrl + '/GET/sub_sections/' + codSubSec);
};

export const getItemsxSubSection = (codSubSec) => {
  return Vue.$http.get(baseApiUrl + '/GET/sub_sections/' + codSubSec + '/items_all');
};

export const getItemsxSubSectionxPage = (codSubSec, itemsPerPage, page) => {
  return Vue.$http.get(
    baseApiUrl +
      '/GET/sub_sections/' +
      codSubSec +
      '/items?cReg=' +
      itemsPerPage +
      '&&nPag=' +
      page,
  );
};
